import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Track } from '@app/core/models/Track';
import { SearchService } from '@app/library/services/search.service';
import { InputWithSuggestionsComponent } from '@radioking/ui/input';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'rk-track-input-with-suggestions',
  templateUrl: './track-input-with-suggestions.component.html',
  styleUrls: ['./track-input-with-suggestions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackInputWithSuggestionsComponent implements OnInit, AfterViewInit {
  @ViewChild(InputWithSuggestionsComponent, { static: true })
  inputSuggestion: InputWithSuggestionsComponent;

  @Input()
  label: string;

  @Input()
  placeholder = '';

  @Input()
  disabled: boolean;

  @Input()
  inModal = false;

  @Input()
  minLengthTrigger = 0;

  @Input()
  isLoadingData = false;

  @Input()
  maxInputLength = 524288;

  @Input()
  hintLabel: string;

  @Output()
  readonly submitted = new EventEmitter<Track>();

  @Output()
  readonly blurred = new EventEmitter<void>();

  @Input()
  set currentValue(data: Track) {
    // Hack needed since the function props is passed after init and the setter is not working properly
    this.inputSuggestion.renderInInputFn = this.renderItem;
    if (data) {
      this.inputSuggestion.currentValue = data;
    }
  }

  inputSubject = new BehaviorSubject('');

  tracks$: Observable<Track[]>;

  @Input()
  schedulerSearch = false;

  constructor(private readonly searchService: SearchService) {}

  ngOnInit() {
    this.tracks$ = this.searchService.createDropdownTracksSearch(
      this.inputSubject,
      this.schedulerSearch,
    );
  }

  renderItem(track: Track): string {
    return [track.title, track.artist].filter(v => v).join(' - ');
  }

  ngAfterViewInit() {}

  onChange(val: string) {
    if (typeof val === 'string') {
      this.inputSubject.next(val);
    }
  }

  onBlur(e: any) {
    if (!e.target.value) {
      this.blurred.emit();
    }
  }
}
